import getMuiTheme from "material-ui/styles/getMuiTheme";
require("../fonts/RobotoRegular/stylesheet.css");


const banmedicaTheme = getMuiTheme({
  fontFamily: "Verdana",
  palette: {
    primary1Color: "#9e9e9e",
    accent1Color: "#C31409",
    primary2Color: "#C31409",
    pickerHeaderColor: "#C31409",
  },
  selectField: {
    textColor: "#fff",
    hintColor: "#fff",
  },
  textField: {
    hintColor: "#fff",
  // floatingLabelColor: palette.disabledColor,
  // disabledTextColor: palette.disabledColor,
  // errorColor: red500,
  // focusColor: palette.primary1Color,
  // backgroundColor: 'transparent',
  // borderColor: palette.borderColor,
  },
});

export default banmedicaTheme;
